import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 1400px;
`;

const Content = styled.div`
  min-width: 1400px;
  width: 1400px;
  min-height: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
`;

const ContentDiv = styled.div`
  margin-top: 50px;
`;

const Logo = styled.img`
  width: 206px;
  height: 67.43px;
  margin-top: 25px;
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 320px;
  background-color: white;
  border-top: 1px solid #cfcfcf;
`;

const FooterContent = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 320px;
  position: relative;
`;

const Company = styled.div`
  color: #5a5a5a;
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  top: 47px;
`;

const CompanyLine = styled.div`
  width: 1400px;
  height: 1px;
  position: absolute;
  top: 87px;
  border: 1px solid #cfcfcf;
`;

const CompanyDes = styled.div`
  top: 108px;
  position: absolute;
  font-size: 16px;
  line-height: 30px;
  color: #888888;
`;

const MobileContaienr = styled.div`
  width: 100%;
  min-width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileContent = styled.div`
  width: 360px;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileLogo = styled.img`
  width: 170px;
  margin-top: 50px;
`;

const MFooterContainer = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 410px;
  min-width: 360px;
  background-color: white;
  border-top: 1px solid #cfcfcf;
`;

const MFooterContent = styled.div`
  width: 360px;
  min-width: 360px;
  height: 410px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MCompany = styled.div`
  position: absolute;
  left: 0px;
  top: 40px;
  color: #5a5a5a;
  font-weight: 600;
`;

const MCompanyLine = styled.div`
  width: 360px;
  height: 1px;
  position: absolute;
  top: 78px;
  border: 1px solid #cfcfcf;
`;

const MCompanyDes = styled.div`
  position: absolute;
  top: 98px;
  line-height: 32px;
  color: #888888;
`;

// Wrapper components for responsive rendering
export function Pc({ children }) {
  const isPc = useMediaQuery({ query: "(min-width: 551px)" });
  return <>{isPc && children}</>;
}

export function Mobile({ children }) {
  const isMobile = useMediaQuery({ query: "(max-width: 550px)" });
  return <>{isMobile && children}</>;
}

function DeleteAccount() {

  // Step management: idle -> input -> loading -> success/error
  const [step, setStep] = useState("idle");
  const [identifier, setIdentifier] = useState(""); // email or phone
  const [deleteError, setDeleteError] = useState(null);

  const handleDeleteClick = () => {
    if (window.confirm('정말로 계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.')) {
      setStep("input");
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    setStep("loading");
    setDeleteError(null);
    try {
      // 실제 Cloud Function 호출
      const response = await fetch(process.env.REACT_APP_DELETE_ACCOUNT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ identifier }),
      });
      if (response.status === 401) {
        setDeleteError('인증 실패: 권한이 없습니다.');
        setStep('error');
        return;
      }
      if (!response.ok) {
        throw new Error(`서버 응답 ${response.status}`);
      }
      setStep('success');
    } catch (err) {
      setDeleteError(err.message);
      setStep('error');
    }
  };

  // Rendering for PC
  const renderContent = () => (
    <ContentDiv>
      <h2>계정 삭제</h2>
      <p>계정을 삭제하면 모든 개인 데이터가 삭제되며, 복구할 수 없습니다.</p>

      {step === "idle" && (
        <button onClick={handleDeleteClick}>⚠️ 계정 삭제하기</button>
      )}

      {step === "input" && (
        <form onSubmit={handleConfirm} style={{ marginTop: 16 }}>
          <input
            type="text"
            placeholder="이메일 또는 전화번호 입력해 주세요."
            value={identifier}
            onChange={e => setIdentifier(e.target.value)}
            required
            style={{ padding: 8, width: 240 }}
          />
          <div style={{ marginTop: 8 }}>
            <button type="submit">확인</button>
            <button type="button" onClick={() => setStep("idle")} style={{ marginLeft: 8 }}>
              취소
            </button>
          </div>
        </form>
      )}

      {step === "loading" && <p>삭제 처리 중…</p>}
      {step === "success" && <p>✅ 계정 삭제 요청이 성공적으로 전송되었습니다.</p>}
      {step === "error" && <p>❌ 삭제 요청 중 오류 발생: {deleteError}</p>}
    </ContentDiv>
  );

  return (
    <>
      {/* PC Layout */}
      <Pc>
        <Container>
          <Content>
            <Logo src="/img/logo.png" alt="Wally Logo" />
            {renderContent()}
          </Content>
        </Container>
        <FooterContainer>
          <FooterContent>
            <Company>(주)월리</Company>
            <CompanyLine />
            <CompanyDes>
              부산광역시 기장군 기장읍 기장대로 82-8 <br />
              사업자 등록번호: 323-88-03325 | 대표: 이승철 <br />
              통신판매신고번호: 2025-부산기장-0252 | 대표번호: 010-6290-2786 <br />
              문의메일: admin@wallykorea.com
            </CompanyDes>
          </FooterContent>
        </FooterContainer>
      </Pc>

      <Mobile>
        <MobileContaienr>
          <MobileContent>
            <MobileLogo src="/img/logo.png" alt="Wally Logo" />
            {renderContent()}
          </MobileContent>
        </MobileContaienr>
        <MFooterContainer>
          <MFooterContent>
            <MCompany>(주)월리</MCompany>
            <MCompanyLine />
            <MCompanyDes>
              부산광역시 기장군 기장읍 기장대로 82-8<br /><br />
              사업자 등록번호: 323-88-03325 | 대표: 이승철<br />
              통신판매신고번호: 2025-부산기장-0252<br />
              대표번호: 010-6290-2786<br />
              문의메일: admin@wallykorea.com
            </MCompanyDes>
          </MFooterContent>
        </MFooterContainer>
      </Mobile>
    </>
  );
}

export default DeleteAccount;
